/**
 * Created by maxime on 2016-08-19.
 */
export function setApplicationSpecificBitrate(sdp, mediabitrate) {
    if (!mediabitrate) {
        return sdp;
    }
    // Remove existing bandwidth lines
    // If media bitrate not set, value will be considered unlimited
    if (mediabitrate.audio || mediabitrate.video || mediabitrate.data) {
        sdp = sdp.replace(/b=AS([^\r\n]+\r\n)/g, '');
    }
    if (mediabitrate.audio && mediabitrate.audio !== 'unlimited') {
        sdp = sdp.replace(/a=mid:audio\r\n/g, 'a=mid:audio\r\nb=AS:' + mediabitrate.audio + '\r\n');
    }
    if (mediabitrate.video && mediabitrate.video !== 'unlimited') {
        sdp = sdp.replace(/a=mid:video\r\n/g, 'a=mid:video\r\nb=AS:' + mediabitrate.video + '\r\n');
    }
    // TO DO: set bitrate for m=application
    return sdp;
}
export function setApplicationMaximumBitrate(sdp, mediaMaxbitrate) {
    var sdpLines = sdp.split('\r\n');
    // TO DO: determine max bitrate per codec and with proper format
    var h264Index = findLine(sdpLines, 'a=rtpmap', 'H264/90000');
    if (!h264Index) {
        return sdp;
    }
    var h264Payload = getCodecPayloadType(sdpLines[h264Index]);
    var rtxIndex = findLine(sdpLines, 'a=rtpmap', 'rtx/90000');
    if (!rtxIndex) {
        return sdp;
    }
    var rtxPayload = getCodecPayloadType(sdpLines[rtxIndex]);
    if (!rtxPayload) {
        return sdp;
    }
    var rtxFmtpLineIndex = findLine(sdpLines, 'a=fmtp:' + rtxPayload.toString());
    if (rtxFmtpLineIndex !== null) {
        var appendrtxNext = '\r\n';
        appendrtxNext += "a=fmtp:" + h264Payload + " x-google-max-bitrate=" + mediaMaxbitrate.video;
        sdpLines[rtxFmtpLineIndex] = sdpLines[rtxFmtpLineIndex].concat(appendrtxNext);
        sdp = sdpLines.join('\r\n');
    }
    else {
        var appendrtxNext = '\r\n';
        appendrtxNext += "a=fmtp:" + h264Payload + " x-google-max-bitrate=" + mediaMaxbitrate.video;
        sdpLines[h264Index] = sdpLines[h264Index].concat(appendrtxNext);
        sdp = sdpLines.join('\r\n');
    }
    return sdp;
}
export function setOpusAttributes(sdp, attrs) {
    var sdpLines = sdp.split('\r\n');
    // Opus
    var opusIndex = findLine(sdpLines, 'a=rtpmap', 'opus/48000');
    if (!opusIndex) {
        return sdp;
    }
    var opusPayload = getCodecPayloadType(sdpLines[opusIndex]);
    if (!opusPayload) {
        return sdp;
    }
    var opusFmtpLineIndex = findLine(sdpLines, 'a=fmtp:' + opusPayload.toString());
    if (opusFmtpLineIndex === null) {
        return sdp;
    }
    var appendOpusNext = '';
    appendOpusNext += '; stereo=' + (attrs.stereo ? attrs.stereo : '1');
    appendOpusNext += '; sprop-stereo=' + (attrs.spropstereo ? attrs.spropstereo : '1');
    if (attrs.maxaveragebitrate) {
        appendOpusNext += '; maxaveragebitrate=' + (attrs.maxaveragebitrate || 128 * 1024 * 8);
    }
    if (attrs.maxplaybackrate) {
        appendOpusNext += '; maxplaybackrate=' + (attrs.maxplaybackrate || 128 * 1024 * 8);
    }
    if (attrs.cbr) {
        appendOpusNext += '; cbr=' + attrs.cbr || '1';
    }
    if (attrs.useinbandfec) {
        appendOpusNext += '; useinbandfec=' + attrs.useinbandfec;
    }
    if (attrs.usedtx) {
        appendOpusNext += '; usedtx=' + attrs.usedtx;
    }
    if (attrs.maxptime) {
        appendOpusNext += '\r\na=maxptime:' + attrs.maxptime;
    }
    sdpLines[opusFmtpLineIndex] = sdpLines[opusFmtpLineIndex].concat(appendOpusNext);
    sdp = sdpLines.join('\r\n');
    return sdp;
}
function findLineInRange(sdpLines, startLine, endLine, prefix, substr) {
    var realEndLine = endLine !== -1 ? endLine : sdpLines.length;
    for (var i = startLine; i < realEndLine; ++i) {
        if (prefix && sdpLines[i].indexOf(prefix) === 0) {
            if (!substr || sdpLines[i].toLowerCase().indexOf(substr.toLowerCase()) !== -1) {
                return i;
            }
        }
    }
    return null;
}
export function findLine(sdpLines, prefix, substr) {
    return findLineInRange(sdpLines, 0, -1, prefix, substr);
}
// Find the line in sdpLines that starts with |prefix| and contains |substr| (case-insensitive search).
// Find the line in a range of sdpLines that starts with |prefix| and contains |substr| (case-insensitive search).
// Gets the codec payload type from an a=rtpmap:X line.
export function getCodecPayloadType(sdpLine) {
    var pattern = new RegExp('a=rtpmap:(\\d+) \\w+\\/\\d+');
    var result = sdpLine.match(pattern);
    return (result && result.length === 2) ? result[1] : null;
}
//# sourceMappingURL=RTCBandwidthHandler.js.map